import { useState, useEffect, useContext, JSX } from 'react';

import { LiveReserveContext } from '../../../../../../../LiveLessonReseveContext';

// シチュエーション各行で表示するラジオボタン
function LiveReserveSituationLineRadioBtn(props: any) {

  const {
    selectedSituation, setSelectedSituation
  } = useContext(LiveReserveContext);

  const category = props.category;
  const info = props.info;
  const isDisabled = props.isDisabled;

  return (
    <>
    {(category && info && !isDisabled) &&
      <span className="radio home-checkbox">
        <input
          id={`situation_${category}_${info.id}`}
          type="radio"
          style={{position: 'relative', top: '-10px', right: 0, zIndex: 1,}}
          name="situation"
          value={info.id}
          checked={selectedSituation === info.id}
          onChange={() => setSelectedSituation(info.id)}
        />
      </span>
    }
    </>
  );
}
  
export default LiveReserveSituationLineRadioBtn;